module.exports = __webpack_public_path__ + "20293d384d4602ce83809c63de00734b.png";